import { z } from 'zod';
import { membershipRoleSchema } from '../roles.js';
export const loginInputSchema = z.object({
    email: z.string().email().max(320),
    password: z.string().min(1).max(200),
});
/** Воркспейс в списке доступных текущему пользователю, вместе с его ролью в нём. */
export const sessionWorkspaceSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    slug: z.string(),
    role: membershipRoleSchema,
});
export const sessionUserSchema = z.object({
    id: z.uuid(),
    email: z.string(),
    name: z.string().nullable(),
    workspaces: z.array(sessionWorkspaceSchema),
});
//# sourceMappingURL=auth.js.map